import { render } from "./AposDocsManagerSelectBox.vue?vue&type=template&id=3bcead60&scoped=true"
import script from "./AposDocsManagerSelectBox.vue?vue&type=script&lang=js"
export * from "./AposDocsManagerSelectBox.vue?vue&type=script&lang=js"

import "./AposDocsManagerSelectBox.vue?vue&type=style&index=0&id=3bcead60&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bcead60"],['__file',"piece-type/ui/apos/components/AposDocsManagerSelectBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3bcead60"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3bcead60', __exports__)) {
    api.reload('3bcead60', __exports__)
  }
  
  module.hot.accept("./AposDocsManagerSelectBox.vue?vue&type=template&id=3bcead60&scoped=true", () => {
    api.rerender('3bcead60', render)
  })

}


export default __exports__